import { OfferedRewardRule, RewardRuleServiceType } from '../models/rewards-v2.models';

/** Primary card headline (e.g. "$50 for 50 Membership Bonus"). */
export function formatOfferedRewardTitle(rule: OfferedRewardRule): string {
  const amount = formatAmount(rule.amount);

  if (rule.items_sold === 1) {
    return `${amount} for each ${rule.name} SOLD`;
  }

  return `${amount} for ${rule.items_sold} ${rule.name}`;
}

export function formatWonToday(amount: number): string {
  return `$${formatAmountValue(amount)} won today`;
}

export function getOfferedRewardIllustration(_serviceType: RewardRuleServiceType): string {
  return '/assets/images/rewards/employee-reward-image.svg';
}

function formatAmount(amount: number): string {
  const value = formatAmountValue(amount);
  return `$${value}`;
}

function formatAmountValue(amount: number): string {
  return Number.isInteger(amount) ? String(amount) : amount.toFixed(2);
}
